module.exports = new __parcel__URL__("promos_base2024_3_3_video.1881bc8f.mp4").toString();